import React, { useState } from "react";
import { BsTrophyFill, BsClockFill, BsSunFill } from "react-icons/bs";

import CV from "../components/cv";

import cvEvents from "../content/cv";

// Optional categories, each toggled by a switch at the top of the page.
// Entries with an empty category are core stations that always show.
// Icons mirror the timeline markers in cv.jsx.
const CATEGORIES = [
    { key: "part-time", label: "Part-time", icon: <BsClockFill /> },
    { key: "prizes", label: "Prizes", icon: <BsTrophyFill /> },
    { key: "summer-school", label: "Summer Schools", icon: <BsSunFill /> },
];

// Dedicated CV page: the full timeline plus switches to reveal optional
// categories of entries.
const CVPage = () => {

    const [enabled, setEnabled] = useState({
        "part-time": false,
        "prizes": false,
        "summer-school": false,
    });

    const toggle = (key) =>
        setEnabled((prev) => ({ ...prev, [key]: !prev[key] }));

    // Core stations (no category) always show; categorised entries only when
    // their switch is on.
    const visible = cvEvents.filter((e) => !e.category || enabled[e.category]);

    return (
        <div className="cv-page">
            <h1 id="CV">Curriculum Vitae</h1>

            <div className="cv-switches">
                {CATEGORIES.map((c) => (
                    <label key={c.key} className="cv-switch">
                        <input
                            type="checkbox"
                            checked={enabled[c.key]}
                            onChange={() => toggle(c.key)}
                        />
                        <span className="cv-switch-slider"></span>
                        <span className="cv-switch-label">
                            <span className="cv-switch-icon">{c.icon}</span>
                            {c.label}
                        </span>
                    </label>
                ))}
            </div>

            <CV events={visible}></CV>
        </div>
    );
};

export default CVPage;
